/* src/app/components/payroll/timesheets/timesheets-add-entries/timesheets-add-entries.component.css */
::ng-deep ppl-dialog ppl-timesheets-add-entries span.serviceDate:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
}
.custom-width {
  max-width: 160px;
  min-width: 50px;
  display: inline-block;
  margin: 0 6px;
}
.p-datatable .p-datatable-tbody > tr > td {
  padding: 0 !important;
}
.control-height {
  height: 30px;
}
.custom-btn-row {
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.error-border {
  border: 1px solid red !important;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
.hyperlink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
.ant-checkbox-wrapper.error-class {
  border: 1px solid red !important;
}
.alert-box li {
  border-bottom: 1px solid #f0dca0;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.alert-box li:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
/*# sourceMappingURL=timesheets-add-entries.component-WXJ7WXIZ.css.map */
